export default __webpack_public_path__ + "static/media/VISA_gray.acc58b9d.svg";